export enum TransactionOriginatorTypeGroup {
  Bills = 'bills',
  Invoices = 'invoices',
  Journals = 'journals',
  Payments = 'payments',
  Vat = 'vat',
}
